<script>
import {appGlobals} from '@/shared/appGlobals'
import {h} from 'vue'

export default {
    name: 'SkeletonPage',

    data() {
        return {
            genericProfilePhotoPath: appGlobals.genericProfilePhotoPath,
        }
    },

    methods: {
        sessionItem() {
            const spongyBone = []

            const yellowMarrow1 = []

            const redMarrow1 = []
            redMarrow1.push(h('div', {class: 'skeleton-element timeslot'}, []))
            yellowMarrow1.push(h('div', {class: 'col-1 cols-sm-0 mb-2'}, redMarrow1))

            const redMarrow2 = []
            redMarrow2.push(h('div', {class: 'skeleton-element session-title'}, []))
            redMarrow2.push(h('div', {class: 'skeleton-element description'}, []))
            yellowMarrow1.push(h('div', {class: 'col-11 col-sm-10 mb-3'}, redMarrow2))

            spongyBone.push(h('div', {class: 'row mt-2'}, yellowMarrow1))

            const yellowMarrow2 = []

            const redMarrow3 = []
            redMarrow3.push(h('div', {class: 'timeslot'}, []))
            yellowMarrow2.push(h('div', {class: 'col-1 cols-sm-0 mb-2'}, redMarrow3))

            const redMarrow4 = []
            redMarrow4.push(h('div', {class: 'skeleton-element session-title'}, []))
            redMarrow4.push(h('div', {class: 'skeleton-element description'}, []))
            yellowMarrow2.push(h('div', {class: 'col-11 col-sm-10 mb-3'}, redMarrow4))

            spongyBone.push(h('div', {class: 'row mt-2 separator'}, yellowMarrow2))

            return h('div', {}, spongyBone)
        },
    },

    props: {
        bones: {
            type: String,
        },
    },

    render() {
        if (this.bones){
            const bones = []
            const boneClasses = this.bones.split(',')
            for (let i = 0; i < boneClasses.length; ++i) {
                const boneClass = boneClasses[i].trim()
                let bone = ''
                if ('bio-card' == boneClass) {
                    const marrow = [h('div', {class: 'card-body'}, [])]
                    bone = h('div', {class: 'card entity-card form-control'}, marrow)

                } else if ('entity-card' == boneClass) {
                    const marrow = [h('div', {class: 'card-body'}, [])]
                    bone = h('div', {class: 'card entity-card'}, marrow)

                } else if ('form-field' == boneClass) {
                    const marrow = [h('input', {class: 'form-control'}, [])]
                    bone=h('div', {class: 'mt-2'}, marrow)
 
                } else if ('presenter' == boneClass) {
                    const marrow = [h('img', {class: 'presenter-graphic', src: this.genericProfilePhotoPath}, [])]
                    bone=h('div', {class: 'presenter-image'}, marrow)
 
                } else if ('presenter-schedule' == boneClass) {
                    const yellowMarrow = []
                    const redMarrow1 = h('div', {class: 'skeleton-element session-date'}, [])
                    yellowMarrow.push(redMarrow1)
                    yellowMarrow.push(redMarrow1)
                    yellowMarrow.push(this.sessionItem())
                    bone=h('div', {class: 'clear-all'}, yellowMarrow)
 
                } else if ('profile-header' == boneClass) {
                    const yellowMarrow = []

                    const redMarrow1 = h('img', {class: 'profile-photo', src: this.genericProfilePhotoPath}, [])
                    yellowMarrow.push(redMarrow1)

                    const redMarrow2 = h('span', {class: 'skeleton-element h1 profile-name', innerHTML: '&nbsp;'}, [])
                    yellowMarrow.push(redMarrow2)

                    bone=h('h1', {}, yellowMarrow)
 
                } else if ('search-field' == boneClass) {
                    const marrow = [h('input', {class: 'form-control search-input fuzzy-search rounded-pill form-control-sm'}, [])]
                    bone = h('div', {class: 'search-box navbar-top-search-box d-lg-block search'}, marrow)

                } else if ('session-item' == boneClass) {
                    bone = this.sessionItem()

                } else if ('spacer' == boneClass) {
                    bone = h('div', {class: 'spacer'}, [])

                } else if ('welcome-card' == boneClass) {
                    const marrow = [h('div', {class: 'card-body'}, [])]
                    bone = h('div', {class: 'card welcome-card'}, marrow)

                } else if ('zip' == boneClass) {
                    const marrow = [h('input', {class: 'form-control postal-code'}, [])]
                    bone=h('div', {class: 'mt-2'}, marrow)

                } else {
                    bone = h('div', {class: 'skeleton-element ' + boneClass}, [])
                }

                bones.push(bone)
            }

            return h('div', {}, bones)

        } else {
            return null
        }
    },
}
</script>

<style scoped>

.clear-all {
    clear: both;
}

.entity-card {
    height: 9rem;
    max-width: 1600px;
}

.form-control {
    max-width: 1024px;
}

@keyframes loading-gradient {
    0% {background-position: 0% 0%}
    60% {background-position: 25% 0%}
    100% {background-position: 100% 0%}
}

.postal-code {
    max-width: 369px;
}

.presenter-graphic {
    max-width: 300px !important;
    height: auto;
}

.presenter-image {
    float: left;
    margin: 0.1em 0.3em 01em 0em;
}

.search-input {
    margin-bottom: 0.6rem;
}

.separator {
    border-bottom: solid var(--phoenix-gray-300) 1px;
    padding-bottom: 1rem;
}

.skeleton-element {
    background: linear-gradient(-90deg,
        var(--phoenix-gray-300),
        var(--phoenix-gray-300),
        var(--phoenix-gray-300),
        var(--phoenix-gray-300),
        var(--phoenix-gray-300),
        var(--phoenix-gray-300),
        var(--phoenix-gray-300),
        var(--phoenix-gray-300),
        var(--phoenix-gray-100),
        var(--phoenix-gray-300),
        var(--phoenix-gray-300),
        var(--phoenix-gray-300),
        var(--phoenix-gray-300),
        var(--phoenix-gray-300),
        var(--phoenix-gray-300),
        var(--phoenix-gray-300),
        var(--phoenix-gray-300),
        var(--phoenix-gray-300));
    background-size: 300% 100%;
    animation: loading-gradient 5s linear reverse infinite running;
}

.skeleton-element.card-body {
    height: 20rem;
}

.skeleton-element.date-string {
    height: 1.4rem;
    margin-bottom: 0.7rem;
    width: 17%;
}

.skeleton-element.description {
    height: 4.2rem;
    margin-bottom: 0.8rem;
}

.skeleton-element.event-header {
    height: 2.5rem;
    margin-bottom: 0.5rem;
    width: 66%;
}

.skeleton-element.event-navigation {
    height: 0.9rem;
    margin-bottom: 0.65rem;
    width: 25rem;
}

.skeleton-element.expand-collapse {
    height: 1.2rem;
    margin-bottom: 0.85rem;
    margin-top: 1.6rem;
    width: 9.5rem;
}

.skeleton-element.form-label {
    height: 0.6rem;
    margin-left: 0.8rem;
    margin-top: 1rem;
    width: 4.4rem;
}

.skeleton-element.h1 {
    height: 2.4rem;
    margin-bottom: 2rem;
}

.skeleton-element.h2 {
    height: 1.9rem;
    margin-bottom: 0.6rem;
    width: 30rem;

}

.skeleton-element.line-8 {
    height: 1rem;
    margin-bottom: 1.4rem;
    width: 8rem;
}

.skeleton-element.line-15 {
    height: 1rem;
    margin-bottom: 1.4rem;
    width: 15rem;
}

.skeleton-element.line-33 {
    height: 1rem;
    margin-bottom: 1.4rem;
    width: 33%;
}

.skeleton-element.line-66 {
    height: 1rem;
    margin-bottom: 1.4rem;
    width: 66%;
}

.skeleton-element.line-88 {
    height: 1rem;
    margin-bottom: 1.4rem;
    width: 88%;
}

.skeleton-element.page-header-3 {
    height: 2.5rem;
    margin-bottom: 0.8rem;
    width: 15rem;
}

.skeleton-element.page-header-4 {
    height: 2.5rem;
    margin-bottom: 0.8rem;
    width: 20rem;
}

.skeleton-element.page-header-5 {
    height: 2.5rem;
    margin-bottom: 0.8rem;
    width: 25rem;
}

.skeleton-element.presenter-bio {
    height: 6.5rem;
    margin-bottom: 0.5rem;
    margin-left: 310px;
}

.skeleton-element.presenter-header {
    height: 2.5rem;
    margin-bottom: 0.5rem;
    width: 14rem;
    margin-left: 310px;
}

.skeleton-element.presenter-title {
    height: 1.4rem;
    margin-bottom: 0.5rem;
    width: 24rem;
    margin-left: 310px;
}

.skeleton-element.presenters-header {
    height: 2.5rem;
    margin-bottom: 0.5rem;
    width: 14rem;
}

.skeleton-element.profile-name {
    margin-left: 0.8rem;
    margin-bottom: 0.5rem;
    padding-left: 25rem;
}

.skeleton-element.profile-photo {
    padding-bottom: -1rem;
}

.skeleton-element.session-date {
    height: 1.2rem;
    margin-bottom: 1rem;
    width: 14rem;
}

.skeleton-element.session-title {
    height: 1.2rem;
    margin-bottom: 1rem;
    width: 14rem;
}

.skeleton-element.subname {
    height: 1.8rem;
    margin-bottom: 0.5rem;
    width: 50%;
}

.skeleton-element.timeslot {
    height: 2.4rem;
    margin-bottom: 0.5rem;
    width: 4rem;
}

.welcome-card {
    height: 20rem;
    max-width: 1600px;
}

</style>